
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/soft/atoms/japan/youth/mitt",
      function () {
        return require("private-next-pages/soft/atoms/japan/youth/mitt/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/soft/atoms/japan/youth/mitt"])
      });
    }
  